import React, { useEffect, useState } from 'react';

import QRCode from 'qrcode.react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Expander } from '../../../components/Common/Expander';
import Table1 from "../../../components/Common/TableContainer";
import TableNP from "../../../components/Common/TableContainerNP";
import { getLabRequestTests } from '../../../store/actions';

import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../../shared';

export const TestOfSamplesTabModal = ({ props, id, showModal, setShowModal, modalRespInfo }) => {

    const [searchData, setSearchData] = useState('');

    const [rowAuthTestIds, setRowAuthTestIds] = useState([]);

    const [check, setCheck] = useState();
    const [checkID, setCheckID] = useState();

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}&statusTest=Autorizado`)); // I just get the items that coincide with the "labRequest" id
    }, [])

    useEffect(() => {
        dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}&search=${searchData}&statusTest=Autorizado`));
        setRowAuthTestIds([]);
    }, [searchData])

    const { labRequestTests, loading, labRequestTest, total, currentPage, } = useSelector(state => ({
        labRequestTests: state.labRequestTestReducer.labRequestTests,
        loading: state.labRequestTestReducer.loading,
        labRequestTest: state.labRequestTestReducer.labRequestTest,
        total: state.labRequestTestReducer.total,
        currentPage: state.labRequestTestReducer.currentPage,
    }), shallowEqual);

    // * Redux fin

    //Register of modal
    const { className } = props;

    const reRender = () => {
        dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}&isInLaboratoryOperations=yes`));
        setShowModal(false);
    }

    const toggle = () => {
        setShowModal(false);
        dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}&isInLaboratoryOperations=yes`));
    }

    const getFilteredItems = () => {
        setSearchData(document.getElementById("TestOfSamplesTabModalinputSearchData").value);
    }

    const onClosed = () => {
        setRowAuthTestIds([]);
        setSearchData('');
    }

    const getPagination = (params) => {
        dispatch(getLabRequestTests(`${params}&labRequest=${id}&statusTest=Autorizado&search=${searchData}`));
    }

    useEffect(() => {
        setRowAuthTestIds(rowAuthTestIds.map((element, index) => { //we update the status of the 'checkStatus' of all the 'UUID' values that match
            if (element.id === checkID) {
                return {
                    id: checkID,
                    checkStatus: check,
                }
            } else {
                return element;
            }
        }))
    }, [rowAuthTestIds.length])

    const onSelected = (value, checkStatus) => { // "Value" already is the selected "id"; "checkStatus" is true or false which is the current check status

        setRowAuthTestIds(rowAuthTestIds => [ //always add to the array the id and the selected status
            ...rowAuthTestIds,
            {
                id: value, // value: 'UUID'
                checkStatus: checkStatus,
            }
        ]);

        setCheck(checkStatus);
        setCheckID(value)
    }

    const submit = () => {

        let filteredArray;
        let filteredArrayAux;
        let deletedRepeatedElementsArray;

        filteredArray = rowAuthTestIds.filter(rowTestId => rowTestId.checkStatus === true); // TODO: Ya lo filtramos, ahora tenemos que  eliminar los elementos repetidos.

        filteredArrayAux = filteredArray.map((item) => item.id);

        deletedRepeatedElementsArray = filteredArrayAux.filter((item, index) => { //Delete repeated elements from an array
            return filteredArrayAux.indexOf(item) === index;
        })

        if (deletedRepeatedElementsArray.length > 0) {
            modalRespInfo(deletedRepeatedElementsArray); // TODO: Aqui le debo de mandar ya solo el array final filtrado y todo
            setTimeout(reRender, 700);
        }
    }

    const columns = React.useMemo(
        () => [
            Expander,
            {
                Header: 'Norma',
                width: '17%',
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original.labTest?.norm?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Método',
                width: '17%',
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original.labTest?.method ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Nombre del ensayo',
                width: '17%',
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original.labTest?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                width: '8%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center">
                        <input className="form-check-input rounded-pill p-3" type="checkbox" id="checkboxNoLabel" onClick={(e) => onSelected(row.original.id, e.target.checked)}></input>
                    </div>
                ),
            },
        ],
        []
    )

    const columns2 = React.useMemo(
        () => [
            {
                Header: 'No. muestra',
                width: '17%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-center mb-2'>Código de muestra: {row.original?.labRequestSample?.sampleControlIdentifier ?? '-'}</div>
                        <div className='text-center mb-1'>
                            <QRCode value={row.original?.labRequestSample?.sampleControlIdentifier ?? '-'} size={50} />
                        </div>
                        <div className='text-center'>Folio de muestra: {row.original?.labRequestSample?.serviceIdentifier ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Descripción de la muestra',
                width: '17%',
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original?.labRequestSample?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Cantidad',
                width: '17%',
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original?.labRequestSample?.quantity ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'UM',
                width: '17%',
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original?.labRequestSample?.unitMeasure?.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Ensayos por muestra',
                width: '17%',
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original?.essays ?? '-'}</div>
                    </div>
                ),
            },
        ],
        []
    )

    const renderRowSubComponent = React.useCallback(
        ({ row }) => (

            <TableNP isAddTableBorderStrap columns={columns2} data={row?.original?.labRequestTestSample} /> // TODO: ¿De dónde saco esta "data" del postman?

        ),
        []
    )

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                outline
                color="success"
                className="me-3 p-2"
                icon="mdi-content-save"
                label="Guardar"
                onClick={submit}
            />
            <BaseCustomButton
                outline
                color="danger"
                className="me-3 p-2"
                icon="mdi-close-circle"
                label="Cancelar"
                onClick={toggle}
            />
        </div>
    );

    const title = (
        <div className='d-flex ms-3 p-0'>
            <label className='m-0 p-0'><h4 className='text-primary m-0 ps-4'>Registro de ensayos</h4></label>
        </div>
    );


    return (
        <>
            <BaseCustomModal
                title={title} 
                isModalOpen={showModal}
                handleCancel={toggle}
                onClosed={onClosed}
                centered
                zIndex={9999}
                width="80%"
                className={className}
                footer={buttons}
            >
                <GradientDecorationLine />

                <div className="px-4 mx-3">
                    <div className="row p-0 m-0 d-flex align-items-center w-100">
                        <div className="col-12 col-md-6 col-lg-10">
                            <input
                                type="search"
                                id="TestOfSamplesTabModalinputSearchData"
                                className="form-control rounded-3"
                                placeholder="Buscar"
                                aria-label="Search"
                            />
                        </div>
                        <BaseCustomButton
                            color="dark"
                            className="col-12 col-md-6 col-lg-2 rounded-3"
                            onClick={getFilteredItems}
                            label="Buscar"
                            icon="mdi mdi-magnify me-1"
                        />
                    </div>

                    <div className="px-0 py-2">
                        <Table1
                            renderRowSubComponent={renderRowSubComponent}
                            currentPage={currentPage}
                            getPagination={getPagination}
                            total={total}
                            loading={loading}
                            isAddTableBorderStrap
                            columns={columns}
                            data={labRequestTests}
                        />
                    </div>
                </div>

                <GradientDecorationLine />
            </BaseCustomModal>
        </>
    )
}
